import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import {ComponentBase} from '@drl/core/component-base';
import {AddNewRecordComponent} from './add-record-modal/add-record.component';
import {NbDialogService} from '@nebular/theme';
import {BulkUploadComponent} from '@drl/shared/components/header/bulk-upload/bulk-upload.component';
import {Appointment} from '@drl/shared/models';
import {PatientDataFacadeService} from './patient-data-facade.service';
import {AppointmentBulk} from './appointment-bulk.model';
import {ToastrService} from 'ngx-toastr';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {SystemStoreFacadeService} from '@drl/core/store/system-store-facade.service';
import {map} from 'lodash';
import {CsvType, csvTypeMap} from '@drl/shared/utility/csv-type.utility';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'app-data-upload',
  templateUrl: './data-upload.component.html',
  styleUrls: [],
})
export class DataUploadComponent extends ComponentBase {
  constructor(
    private readonly dialogService: NbDialogService,
    private readonly patientDataService: PatientDataFacadeService,
    private readonly toastrService: ToastrService,
    private readonly confirmationService: ConfirmationService,
    private readonly systemStoreFacade: SystemStoreFacadeService,
    protected readonly translateSvc: TranslateService,
  ) {
    super();
  }
  dropdownOptions = [
    {label: 'Appointments', value: 'Appointments'},
    {label: 'Patients', value: 'Patients'},
    {label: 'Prescriptions', value: 'Prescriptions'},
    {label: 'Therapy Plans', value: 'Therapy Plans'},
  ];
  locale: string;
  logo = '/assets/notes.png';
  apptList: Appointment[] = [];
  selectedDropDownValue: string = CsvType.Appointment;
  btnEnabledOption = CsvType.Appointment;
  loading: boolean;
  dataUploadPath = 'main/data-upload';

  ngOnInit() {
    this.systemStoreFacade.getLocale().subscribe(locale => {
      this.locale = locale;
      this.dropdownOptions = map(
        csvTypeMap(this.translateSvc, this.locale),
        (cat, key) => {
          return {
            label: cat.name,
            value: cat.key,
          };
        },
      );
    });
  }

  addNewRecord(flag: boolean, appt: Appointment) {
    if (!flag && this.apptList.length === 10) {
      this.toastrService.error(
        this.translateSvc.instant('max10RecordMsg'),
        this.translateSvc.instant('errorLbl'),
      );
      return;
    }
    let context = {};
    if (flag) {
      context = {
        appt,
      };
    }

    this._subscriptions.push(
      this.dialogService
        .open(AddNewRecordComponent, {
          context,
        })
        .onClose.subscribe(res => {
          if (res && !res.error) {
            const idx = this.apptList.findIndex(appt => {
              return appt.uniqId === res.appt.uniqId;
            });
            if (idx !== -1) {
              this.apptList[idx] = res.appt;
            } else {
              this.apptList.push(res.appt);
            }
          }
        }),
    );
  }

  uploadRecords() {
    this.loading = true;
    const appointmentBulk = new AppointmentBulk();
    appointmentBulk.appointments = [];
    for (let appt of this.apptList) {
      if (appt.apptDateTimeString) {
        appt.apptDate = moment(appt.apptDateTimeString).toDate();
      }
      let formattedAppt: any = {...appt};
      // Remove invalid field (from payload, not original)
      delete formattedAppt.apptTime;

      // Map correct field name
      formattedAppt.appointmentTime = appt.apptTime;
      // Map patient fields
      formattedAppt.patientName = appt.patientFullName;
      formattedAppt.patientPhone = appt.patientMobileNumber;
      appointmentBulk.appointments.push(formattedAppt);
    }
    this.patientDataService
      .createBulkAppointment(appointmentBulk)
      .subscribe(() => {
        this.toastrService.success(
          this.translateSvc.instant('recordUploadSuccess'),
          this.translateSvc.instant('successLbl'),
        );
        this.loading = false;
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
  }

  uploadConfirm() {
    this.confirmationService.confirm({
      key: 'updateConfirm',
      message: this.translateSvc.instant('bulkUploadConfirmationText'),
      accept: () => {
        this.uploadRecords();
      },
    });
  }

  ondropdownValueChange() {
    this.apptList = [];
  }

  openUploadCsvDialog() {
    this._subscriptions.push(
      this.dialogService.open(BulkUploadComponent).onClose.subscribe(res => {}),
    );
  }
}
